<template>
    <locations-show-page parent v-slot:default="_parent">
        <sub-item-show-view v-slot:default="_">
            <location-shift-edit-form :disabled="_.itemDisabled" v-model="_.item" :parent-model="_parent.item" />
        </sub-item-show-view>
    </locations-show-page>
</template>

<script>
    import LocationsShowPage from '../../show'
    import SubItemShowView from '../../../../Item/Views/SubItemShowView'
    import LocationShiftEditForm from './Shared/LocationShiftEditForm'

    export default {
        name: 'LocationsShowShiftsEditPage',
        inheritAttrs: false,
        components: {
            LocationsShowPage,
            SubItemShowView,
            LocationShiftEditForm,
        },
    }
</script>

<style scoped>

</style>